import visibleKey from './visibleKey';
export default () => {
    return !document[visibleKey.hiddenKey];
};
